import NiceModal from "@ebay/nice-modal-react";
import Notifications from "@components/Drawer/Drawers/Notifications";
import LeaveProgramModal from "@components/LeaveProgramModal";
import HistoryModal from "@components/HistoryModal";
import RedeemAwardModal from "./components/RedeemAwardModal";
import StorySwiperModal from "./components/StorySwiperModal";
import WelcomeBrandsModal from "./components/WelcomeBrandsModal";
import HowToUseModal from "./components/HowToUseModal";
import PartnerAvailableModal from "./components/PartnerAvailableModal";
import WheelPrizeModal from "./components/WinWheelModal";
import ObjectModal from "./components/ObjectModal";
import LastObjectModal from "./components/LastObjectModal";
import ErrorWhellModal from "./components/ErrorWheelModal";
import RedeemCalendar2024 from "@components/RedeemCalendar2024";
import NewYearPointsModal from "@components/NewYearPointsModal";
import NewYearAwardModal from "@components/NewYearAwardModal";
import ErrorModal from "@components/ErrorModal";
// import PreviewModal from "@pages/Activities/Activities/Mechanics/FashionWeek/PreviewModal";
import MazeIntroModal from "@components/MazeIntroModal";
import Quiz_13Modal from "@components/Quiz_13Modal";
import RedeemedAuctionReward from "./components/RedeemedAuctionReward";
import EasterEggModal from "@components/EasterEggModal";
import VideoModal from "@components/VideoModal";
import ConnectModal from "@pages/UltraInsider/components/ConnectModal";
import DownloadAppModal from "@pages/UltraInsider/components/DownloadAppModal";
import StaticAwardModal from "@components/StaticAwardModal";
import InspirationJourney from "@components/InspirationJourney";
import RevealImageQuizModal from "@components/RevealImageQuizModal";
import VuseFragrance2025Modal from "@components/VuseFragrance2025Modal";
import VuseFragrance2025RedemModal from "@components/VuseFragrance2025RedemModal";
import AuctionModal from "@components/AuctionModal";
import QrScannerModal from "@components/QrScannerModal";
import QrErrorModal from "@components/QrErrorModal";
import DjConsoleModal from "@components/DjConsoleModal";
import QRAwardInfoModal from "@components/QRAwardInfoModal";

NiceModal.register("drawer-notifications", Notifications);
NiceModal.register("leave-program-modal", LeaveProgramModal);
NiceModal.register("history-modal", HistoryModal);
NiceModal.register("redeem-award-modal", RedeemAwardModal);
NiceModal.register("partner-available-modal", PartnerAvailableModal);
NiceModal.register("story-wrapper-modal", StorySwiperModal);
NiceModal.register("welcome-brands-modal", WelcomeBrandsModal);
NiceModal.register("howToUse-modal", HowToUseModal);
NiceModal.register("wheel-prize-modal", WheelPrizeModal);
NiceModal.register("wheel-cant-spin-modal", WheelPrizeModal);
NiceModal.register("found-object-modal", ObjectModal);
NiceModal.register("last-found-object-modal", LastObjectModal);
NiceModal.register("error-wheel-modal", ErrorWhellModal);
NiceModal.register("redeem-calendar-2024", RedeemCalendar2024);
NiceModal.register("new-year-points", NewYearPointsModal);
NiceModal.register("new-year-award", NewYearAwardModal);
NiceModal.register("error-modal", ErrorModal);
// NiceModal.register("fashion-week-preview", PreviewModal);
NiceModal.register("maze-intro-modal", MazeIntroModal);
NiceModal.register("quiz-13-modal", Quiz_13Modal);
NiceModal.register("redeemed-auction-reward", RedeemedAuctionReward);
NiceModal.register("easter-egg-modal", EasterEggModal);
NiceModal.register("video-modal", VideoModal);
NiceModal.register("connect-modal", ConnectModal);
NiceModal.register("download-app-modal", DownloadAppModal);
NiceModal.register("static-award-modal", StaticAwardModal);
NiceModal.register("journey-modal", InspirationJourney);
NiceModal.register("reveal-image-quiz-modal", RevealImageQuizModal);
NiceModal.register("vuse-fragrance-2025-modal", VuseFragrance2025Modal);
NiceModal.register(
  "fragrance-2025-redeem-award-modal",
  VuseFragrance2025RedemModal,
);
NiceModal.register("auction-modal", AuctionModal);
NiceModal.register("qr-scanner-modal", QrScannerModal);
NiceModal.register("qr-error-modal", QrErrorModal);
NiceModal.register("dj-console-modal", DjConsoleModal);
NiceModal.register("qr-award-info-modal", QRAwardInfoModal);
